import React, { useEffect, useState } from 'react';
import { FaEdit, FaTrash, FaPlus, FaCalendarAlt, FaClock, FaEye, FaArchive } from 'react-icons/fa';


import {
  Table, TableBody, TableCell, TableContainer, TableHead,
  TableRow, Paper, Typography, Box, CircularProgress,
  IconButton, Button, Stack, TableSortLabel, Tooltip
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';
import showTimeServices from "../../services/externalServices/TicketServices/showTimeServices"

const ShowSchedules = () => {
  const [schedules, setSchedules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sortConfig, setSortConfig] = useState({ key: 'validityFrom', direction: 'asc' });
  const [showArchived, setShowArchived] = useState(false); // New state for toggle

  const navigate = useNavigate();
  const { role = '', accessList = [] } = JSON.parse(localStorage.getItem('admin')) || {};
  const isTicketAdmin = role === 'ticket-admin';
  const theatreName = accessList?.[0];

  useEffect(() => {
    const fetchSchedules = async () => {
      try {
        const response = await showTimeServices.getAllShowSchedules(isTicketAdmin ? theatreName : '');


        console.log('response of the show schedules', response);

        // console.log("response at the fetching the details", response);
        setSchedules(response);
      } catch (err) {
        console.error("Error fetching show schedules:", err);
        setError('Failed to fetch schedules');
      } finally {
        setLoading(false);
      }
    };

    fetchSchedules();
  }, [isTicketAdmin, theatreName]);

  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc'
    }));
  };

  // const getStatusIcon = (movie) => {
  //   if (movie?.isArchived) {
  //     return (
  //       <Tooltip title="Expired" arrow>
  //         <span role="img" aria-label="expired">⛔</span>
  //       </Tooltip>
  //     );
  //   }
  //   if (movie?.isReadyForBooking) {
  //     return (
  //       <Tooltip title="Currently Live" arrow>
  //         <span role="img" aria-label="live">🎬</span>
  //       </Tooltip>
  //     );
  //   }
  //   return (
  //     <Tooltip title="Coming Soon" arrow>
  //       <span role="img" aria-label="upcoming">🕒</span>
  //     </Tooltip>
  //   );
  // };



  // Filter schedules based on archived status
  // const filteredSchedules = showArchived
  //   ? schedules.filter(schedule => schedule.movieId?.isArchived)
  //   : schedules.filter(schedule => !schedule.movieId?.isArchived);




  const filteredSchedules = showArchived
    ? schedules
      .map(schedule => ({
        ...schedule,
        theatreDetails: schedule.theatreDetails.filter(detail => detail.isArchived)
      }))
      .filter(schedule => schedule.theatreDetails.length > 0)
    : schedules
      .map(schedule => ({
        ...schedule,
        // theatreDetails: schedule.theatreDetails.filter(detail => detail.isReadyForBooking)
        theatreDetails: schedule.theatreDetails.filter(detail => !detail.isArchived)
      }))
      .filter(schedule => schedule.theatreDetails.length > 0);





  const sortedSchedules = [...filteredSchedules].sort((a, b) => {
    const aDate = new Date(a[sortConfig.key]);
    const bDate = new Date(b[sortConfig.key]);
    return sortConfig.direction === 'asc' ? aDate - bDate : bDate - aDate;
  });



  // const handleEdit = (schedule) => {
  //   navigate('/editValidity', { state: { schedule } });
  // };

  const handleEdit = (schedule, detail) => {
    navigate('/editValidity', { 
      state: { 
        schedule,
        selectedTheatre: detail
      }
    });
  };
  



  // const handleDelete = async (scheduleId) => {
  //   const confirm = window.confirm("Are you sure you want to delete this scheduled time?");
  //   if (!confirm) return;

  //   try {
  //     const response = await showTimeServices.deleteShowSchedule(scheduleId);

  //     console.log('response in the handle delte', response.message);

  //     const message = response?.message || "";

  //     // ✅ Show success message
  //     alert("⚠️" + message);
  //     // Remove the deleted schedule from state
  //     setSchedules(prev => prev.filter(schedule => schedule._id !== scheduleId));


  //     // ✅ Only update state if deletion actually happened
  //     // if (message === "Show schedule deleted successfully.") {
  //     //     setMovies((prev) => prev.filter((m) => m._id !== id));
  //     // }
  //     // setMovies((prev) => prev.filter((m) => m._id !== id));
  //   } catch (error) {
  //     // ❌ Show error message from backend
  //     const errorMessage = error?.response?.message || "Failed to delete movie.";
  //     alert("❌ " + errorMessage);
  //     console.error("Delete movie error:", error);
  //   }
  // };




  // const handleDelete = async (scheduleId, theatreId) => {
  //   const confirm = window.confirm("Are you sure you want to delete this theatre's schedule?");
  //   if (!confirm) return;
  
  //   try {
  //     const schedule = schedules.find(s => s._id === scheduleId);
  //     if (!schedule) return;
  
  //     // remove ONLY the selected theatre
  //     // const updatedTheatreDetails = schedule.theatreDetails.filter(
  //     //   d => String(d.theatreId._id) !== String(theatreId)
  //     // );


  //     const updatedTheatreDetails = schedule.theatreDetails.map(d => {
  //       if (String(d.theatreId._id) === String(theatreId)) {
  //         return { theatreId: d.theatreId._id, _delete: true };
  //       }
  //       return d;
  //     });
      
  
  //     // If no theatre left → delete whole schedule
  //     if (updatedTheatreDetails.length === 0) {
  //       await showTimeServices.deleteShowSchedule(scheduleId);
  //       setSchedules(prev => prev.filter(s => s._id !== scheduleId));
  //       alert("Deleted entire schedule (no theatres remaining)");
  //       return;
  //     }
  
  //     // Otherwise update schedule with remaining theatres
  //     // const payload = {
  //     //   ...schedule,
  //     //   theatreDetails: updatedTheatreDetails
  //     // };

  //     const payload = {
  //       validityFrom: schedule.validityFrom,
  //       validityUntil: schedule.validityUntil,
  //       theatreDetails: updatedTheatreDetails,
  //       forceUpdate: false
  //     };
      


      
  
  //     const response = await showTimeServices.updateShowSchedule(scheduleId, payload);
  
  //     alert(response.message || "Updated successfully");
  
  //     // Update UI
  //     setSchedules(prev =>
  //       prev.map(s =>
  //         s._id === scheduleId ? { ...s, theatreDetails: updatedTheatreDetails } : s
  //       )
  //     );
  
  //   } catch (err) {
  //     console.error(err);
  //     alert("Failed to delete");
  //   }
  // };


  const handleDelete = async (scheduleId, theatreId) => {
    const confirm = window.confirm("Are you sure you want to delete this theatre's schedule?");
    if (!confirm) return;
  
    try {
      // ✅ Get the ORIGINAL schedule (not filtered)
      const originalSchedules = await showTimeServices.getAllShowSchedules('');
      const schedule = originalSchedules.find(s => s._id === scheduleId);
      
      if (!schedule) {
        console.log('❌ Schedule not found');
        return;
      }
  
      console.log('🔍 TheatreId to delete:', theatreId);
  
      // ✅ Mark the theatre with _delete: true - but include ALL theatres
      const updatedTheatreDetails = schedule.theatreDetails.map(d => {
        const currentTheatreId = d.theatreId._id || d.theatreId;
        if (String(currentTheatreId) === String(theatreId)) {
          console.log('✅ MATCH FOUND - marking for deletion');
          return { 
            ...d,
            _delete: true 
          };
        }
        return d;
      });
  
      // If no theatres remain after this delete action, delete the entire schedule
      const theatresRemaining = updatedTheatreDetails.filter(d => !d._delete);
      console.log('🔍 Theatres remaining:', theatresRemaining.length);
      
      if (theatresRemaining.length === 0) {
        console.log('🗑️ Deleting entire schedule');
        await showTimeServices.deleteShowSchedule(scheduleId);
        setSchedules(prev => prev.filter(s => s._id !== scheduleId));
        alert("Deleted entire schedule (no theatres remaining)");
        return;
      }
  
      // Prepare payload to send to backend
      const payload = {
        validityFrom: schedule.validityFrom,
        validityUntil: schedule.validityUntil,
        theatreDetails: updatedTheatreDetails,
        forceUpdate: false
      };
  
      console.log('📤 Payload theatres count:', updatedTheatreDetails.length);
  
      // Call the backend update API
      const response = await showTimeServices.updateShowSchedule(scheduleId, payload);
  
      // ✅ Refresh the data to get the updated state
      const refreshedSchedules = await showTimeServices.getAllShowSchedules(isTicketAdmin ? theatreName : '');
      setSchedules(refreshedSchedules);
      
      alert(response.message || "Theatre schedule deleted successfully");
  
    } catch (err) {
      console.error('💥 Delete error:', err);
      alert("Failed to delete: " + (err.response?.data?.message || err.message));
    }
  };
  




  // const handleDelete = async (scheduleId, theatreId) => {
  //   if (!window.confirm("Are you sure you want to delete this theatre's schedule?")) {
  //     return;
  //   }
  
  //   try {
  //     const schedule = schedules.find(s => s._id === scheduleId);
  //     if (!schedule) return;
  
  //     // Build correct theatreDetails payload
  //     const updatedTheatreDetails = schedule.theatreDetails.map(d => {
  //       const id = String(d.theatreId._id || d.theatreId);
  
  //       if (id === String(theatreId)) {
  //         return { theatreId: id, _delete: true };
  //       }
  
  //       return {
  //         theatreId: id,
  //         shows: d.shows,
  //         isReadyForBooking: d.isReadyForBooking,
  //         isArchived: d.isArchived
  //       };
  //     });
  
  //     const payload = {
  //       validityFrom: schedule.validityFrom,
  //       validityUntil: schedule.validityUntil,
  //       theatreDetails: updatedTheatreDetails,
  //       forceUpdate: false
  //     };
  
  //     const response = await showTimeServices.updateShowSchedule(scheduleId, payload);
  
  //     alert(response.message);
  
  //     // Refresh UI
  //     setSchedules(prev =>
  //       prev.map(s =>
  //         s._id === scheduleId
  //           ? {
  //               ...s,
  //               theatreDetails: s.theatreDetails.filter(
  //                 t => String(t.theatreId._id || t.theatreId) !== String(theatreId)
  //               )
  //             }
  //           : s
  //       )
  //     );
      
  
  //   } catch (err) {
  //     console.error(err);
  //     alert("Failed to delete theatre");
  //   }
  // };
  
  

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" mt={4}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return <Typography color="error">{error}</Typography>;
  }

  // const getStatusBadge = (movie) => {
  //   if (movie?.isArchived) return (
  //     <span className="px-2 py-1 text-xs font-medium tracking-wide text-red-800 bg-red-100 rounded-full">
  //       Expired
  //     </span>
  //   );
  // }



  const formatDateToDDMMYYYY = (dateInput) => {
    if (!dateInput) return '';

    // Handle both string dates and Date objects
    const date = dateInput instanceof Date ? dateInput : new Date(dateInput);

    // Check if the date is valid
    if (isNaN(date.getTime())) return 'Invalid date';

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };



  // For the update 

  // const handleToggleArchive = async (scheduleId, theatreId) => {
  //   try {
  //     const schedule = schedules.find(s => s._id === scheduleId);
  //     if (!schedule) return;
  
  //     const updatedTheatreDetails = schedule.theatreDetails.map(detail =>
  //       String(detail.theatreId._id) === String(theatreId)
  //         ? { ...detail, isArchived: !detail.isArchived }
  //         : detail
  //     );
  
  //     const updatedPayload = {
  //       validityFrom: schedule.validityFrom,
  //       validityUntil: schedule.validityUntil,
  //       theatreDetails: updatedTheatreDetails
  //     };
  
  //     const response = await showTimeServices.updateShowSchedule(scheduleId, updatedPayload);
  
  //     if (response?.message) {
  //       alert(`✅ ${response.message}`);
  //     }
  
  //     // Update state locally
  //     setSchedules(prev =>
  //       prev.map(s =>
  //         s._id === scheduleId ? { ...s, theatreDetails: updatedTheatreDetails } : s
  //       )
  //     );
  //   } catch (err) {
  //     console.error('Archive toggle error:', err);
  //     alert('❌ Failed to toggle archive');
  //   }
  // };


  const handleToggleArchive = async (scheduleId, theatreId) => {
    try {
      const schedule = schedules.find(s => s._id === scheduleId);
      if (!schedule) return;
  
      const updatedTheatreDetails = schedule.theatreDetails.map(detail =>
        String(detail.theatreId._id) === String(theatreId)
          ? { ...detail, isArchived: !detail.isArchived }
          : detail
      );
  
      const updatedPayload = {
        validityFrom: schedule.validityFrom,
        validityUntil: schedule.validityUntil,
        theatreDetails: updatedTheatreDetails,
        forceUpdate: false // ✅ Add forceUpdate flag
      };
  
      const response = await showTimeServices.updateShowSchedule(scheduleId, updatedPayload);
      
      // ✅ FIXED: Check for error message in successful response (similar to your other fix)
      if (response.message && response.message.includes('❌ Cannot')) {
        const confirmMessage = `${response.message}\n\nDo you want to proceed with archiving/unarchiving anyway?`;
        
        if (window.confirm(confirmMessage)) {
          try {
            const forcePayload = {
              ...updatedPayload,
              forceUpdate: true // ✅ Force update to skip validations
            };
            
            const forceResponse = await showTimeServices.updateShowSchedule(scheduleId, forcePayload);
            alert(`✅ ${forceResponse.message}`);
            
            // Update state locally
            setSchedules(prev =>
              prev.map(s =>
                s._id === scheduleId ? { ...s, theatreDetails: updatedTheatreDetails } : s
              )
            );
          } catch (forceError) {
            console.error('Force archive toggle failed:', forceError);
            alert('❌ Failed to toggle archive');
          }
        }
      } else {
        // ✅ Normal success case
        alert(`✅ ${response.message}`);
        
        // Update state locally
        setSchedules(prev =>
          prev.map(s =>
            s._id === scheduleId ? { ...s, theatreDetails: updatedTheatreDetails } : s
          )
        );
      }
  
    } catch (err) {
      console.error('Archive toggle error:', err);
      alert('❌ Failed to toggle archive');
    }
  };
  



  return (
    <div className="min-h-screen p-6">
      <div className="flex flex-col justify-between gap-4 mb-8 sm:flex-row sm:items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Show Schedules</h1>
          <p className="mt-1 text-sm text-gray-500">
            {showArchived ? 'Viewing archived schedules' : 'Viewing active schedules'}
          </p>
        </div>

        <div className="flex gap-3">
          <button
            onClick={() => setShowArchived(!showArchived)}
            className={`flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium rounded-lg ${showArchived
              ? 'bg-gray-200 text-gray-800 hover:bg-gray-300'
              : 'bg-yellow-100 text-yellow-800 hover:bg-yellow-200'
              }`}
          >
            {showArchived ? (
              <>
                <FaEye className="w-4 h-4" />
                View Active
              </>
            ) : (
              <>
                <FaArchive className="w-4 h-4" />
                View Archived
              </>
            )}
          </button>

          <button
            onClick={() => navigate('/addValidity')}
            className="flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-white transition-colors bg-black rounded-lg"
          >
            <FaPlus className="w-4 h-4" />
            New Schedule
          </button>
        </div>
      </div>

      {sortedSchedules.length === 0 ? (
        <div className="p-8 text-center bg-gray-100 rounded-lg">
          <p className="text-gray-500">
            {showArchived
              ? 'No archived schedules found'
              : 'No active schedules found'}
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {sortedSchedules
            .filter(schedule => schedule.movieId?.name) // Filter schedules with movie names
            .map((schedule) =>
              schedule.theatreDetails.map((detail, index) => (
                <div key={`${schedule._id}-${index}`} className="flex flex-col p-6 bg-white border rounded-xl border-gray-200 hover:border-blue-100 hover:shadow-lg transition-all h-full">
                  {/* Content */}
                  <div className="flex-grow">
                    <div className="flex items-start justify-between mb-4">
                      <div>
                        <h3 className="text-lg font-semibold text-gray-900">{schedule.movieId?.name}</h3>
                        <p className="mt-1 text-sm text-black">{detail.theatreId?.name}</p>
                      </div>
                      {/* {schedule.movieId?.isArchived && (
                        <span className="px-2 py-1 text-xs font-medium tracking-wide text-red-800 bg-red-100 rounded-full">
                          Archived
                        </span>
                      )} */}
                    </div>

                    <div className="space-y-3">
                      <div className="flex items-center gap-2 text-sm text-black">
                        <FaCalendarAlt className="w-4 h-4 text-green-500" />
                        <span>
                          {formatDateToDDMMYYYY(schedule.validityFrom)} - {' '}
                          {formatDateToDDMMYYYY(schedule.validityUntil)}
                        </span>
                      </div>

                      {/* <div className="flex items-center gap-2 text-sm text-gray-600">
                        <FaClock className="w-6 h-4 text-orange-500" />
                        <span className="font-medium text-black">
                          {detail.showTimes.join(', ')}
                        </span>
                      </div> */}









                      <div className="flex items-start gap-2 text-sm text-gray-600">
                        <FaClock className="w-6 h-4 text-orange-500 mt-1" />
                        <div className="flex flex-col gap-1">
                          {detail.shows?.map((show, idx) => (
                            <span key={idx} className="text-black">
                              🎬 {show.time} | {show.language} | {show.format}
                            </span>
                          ))}
                        </div>
                      </div>


                    </div>
                  </div>

                  {/* Sticky Bottom Buttons */}
                  <div className="mt-6 pt-4 border-t border-gray-100">
                    <div className="flex gap-2">
                      <button
                        // onClick={() => handleEdit(schedule)}
                        onClick={() => handleEdit(schedule, detail)}

                        className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-black transition-colors hover:bg-gray-100 rounded-md w-1/2 justify-center"
                      >
                        <FaEdit className="w-4 h-4" />
                        Edit
                      </button>
                      <button
                        // onClick={() => handleDelete(schedule._id)}
                        onClick={() => handleDelete(schedule._id, detail.theatreId._id)}

                        className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-red-600 transition-colors hover:bg-red-100 rounded-md w-1/2 justify-center"
                      >
                        <FaTrash className="w-4 h-4" />
                        Delete
                      </button>

                      {/* <button
                        onClick={() => handleToggleArchive(schedule._id, detail.theatreId?._id)} 
                        className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-yellow-600 transition-colors hover:bg-yellow-100 rounded-md w-1/2 justify-center"
                      >
                        < FaArchive className="w-4 h-4" />
                        Archive
                      </button> */}
                     

                      <button
                        onClick={() => handleToggleArchive(schedule._id, detail.theatreId?._id)}
                        className={`flex items-center gap-2 px-3 py-1.5 text-sm font-medium ${detail.isArchived
                            ? 'text-green-600 hover:bg-green-100'
                            : 'text-yellow-600 hover:bg-yellow-100'
                          } rounded-md w-full justify-center`}
                      >
                        {detail.isArchived ? 'Unarchive' : 'Archive'}
                      </button>
                    </div>
                  </div>
                </div>
              ))
            )}
        </div>
      )}
    </div>
  );



};

export default ShowSchedules;



